export default {
  CHAT_NOT_EXISTS: 'CHAT_NOT_EXISTS',

  CHAT_ASSIGNED: '@external-app-event/chat-assigned',
  CHAT_CLOSED_BY_OPERATOR: '@external-app-event/chat-closed-by-operator',
  CHAT_CLOSED_BY_ADMIN: '@external-app-event/chat-closed-by-admin',
  CHAT_DECLINED_BY_ADMIN: '@external-app-event/chat-declined-by-operator',
  CHAT_NOT_PICKED_UP: '@external-app-event/chat-not-picked-up',

  OPERATOR_SEND_MESSAGE: '@external-app-event/operator-send-message',
  OPERATOR_TRANSLATE_MESSAGE: '@external-app-event/operator-translate-message',
  OPERATOR_TYPING: '@external-app-event/operator-typing',
  OPERATOR_LOST_CONNECTION: '@external-app-event/operator-lost-connection',

  VISITOR_SEND_MESSAGE: '@external-app-event/visitor-send-message',

  OFFLOAD_START: '@external-app-event/offload-start',
  OFFLOAD_DECLINED: '@external-app-event/offload-declined',
  OFFLOAD_FAILED: '@external-app-event/offload-failed',

  TRANSFER_START: '@external-app-event/transfer-start',
  TRANSFER_DECLINED: '@external-app-event/transfer-declined',
  TRANSFER_COMPLETED: '@external-app-event/transfer-completed',
  TRANSFER_FAILED: '@external-app-event/transfer-failed',
  TRANSFER_TIMEOUT: '@external-app-event/transfer-timeout',

  ENABLE_FILE_UPLOAD: '@external-app-event/file-upload-enabled',
  DISABLE_FILE_UPLOAD: '@external-app-event/file-upload-disabled',

  OPERATOR_POLLED: '@external-app-event/operator-polled'
};
